import { ca } from '@cian/analytics';
import { getAnalyticsTabName } from './getAnalyticsTabName';

export function trackRateClick(tab: string) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Index_transport',
    label: 'index_transport_more',
    name: 'oldevent',
    useLastProducts: true,
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        block_type: getAnalyticsTabName(tab),
      },
    },
  });
}
